import React from 'react';
import styled from 'styled-components';
import { FilterType } from '../FilterData';

interface Props {
  filters: FilterType;
  setOpenOption: (
    option:
      | null
      | 'type'
      | 'caseNumber'
      | 'region'
      | 'address'
      | 'court'
      | 'itemStatus'
      | 'appraisalPrice'
      | 'minPrice'
      | 'saleDate'
      | 'approvalDate'
      | 'buildingArea'
      | 'landArea'
      | 'bidno'
      | 'progressStatus'
      | 'useArea'
      | 'specialItemCondition',
  ) => void;
}

function SaveFilterOptionList({ filters, setOpenOption }: Props) {
  const foramtDateWithDot = (value: string) => {
    return `${value.replaceAll('-', '.')}`;
  };

  return (
    <OptionList>
      <Option>
        경매/공매
        <SelectedOption onClick={() => setOpenOption('type')}>
          {filters.type === 'a' ? '경매' : '공매'}
          <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
        </SelectedOption>
      </Option>

      {(filters.year || filters.caseNumber) && (
        <Option>
          연도/사건번호
          <SelectedOption onClick={() => setOpenOption('caseNumber')}>
            {filters.year}타경{filters.caseNumber}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {filters.region.length !== 0 &&
        filters.region.every(
          (item) => item.sido || item.sigungu || item.emd,
        ) && (
          <Option>
            지역
            <SelectedOption onClick={() => setOpenOption('region')}>
              {`${filters.region[0].sido} ${filters.region[0].sigungu} ${filters.region[0].emd}`}
              <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
            </SelectedOption>
          </Option>
        )}

      {filters.address && (
        <Option>
          지역
          <SelectedOption onClick={() => setOpenOption('address')}>
            {filters.address}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {filters.type === 'a' && filters.court && (
        <Option>
          법원
          <SelectedOption onClick={() => setOpenOption('court')}>
            {filters.court}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {filters.itemStatus.length !== 0 && (
        <Option>
          물건종류
          <SelectedOption onClick={() => setOpenOption('itemStatus')}>
            {filters.itemStatus.length > 1
              ? `${filters.itemStatus[0]} 외 +${filters.itemStatus.length - 1}`
              : `${filters.itemStatus[0]}`}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {filters.progressStatus && (
        <Option>
          진행단계
          <SelectedOption onClick={() => setOpenOption('progressStatus')}>
            {filters.progressStatus}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {(filters.appraisalPrice.min || filters.appraisalPrice.max) && (
        <Option>
          감정가
          <SelectedOption onClick={() => setOpenOption('appraisalPrice')}>
            {filters.appraisalPrice.min !== ''
              ? `${Number(filters.appraisalPrice.min).toLocaleString()}만원`
              : ''}{' '}
            ~{' '}
            {filters.appraisalPrice.max !== ''
              ? `${Number(filters.appraisalPrice.max).toLocaleString()}만원`
              : ''}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {(filters.minPrice.min || filters.minPrice.max) && (
        <Option>
          최저가
          <SelectedOption onClick={() => setOpenOption('minPrice')}>
            {filters.minPrice.min !== ''
              ? `${Number(filters.minPrice.min).toLocaleString()}만원`
              : ''}{' '}
            ~{' '}
            {filters.minPrice.max !== ''
              ? `${Number(filters.minPrice.max).toLocaleString()}만원`
              : ''}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {(filters.saleDate.start || filters.saleDate.end) && (
        <Option>
          매각기일
          <SelectedOption onClick={() => setOpenOption('saleDate')}>
            {foramtDateWithDot(filters.saleDate.start)} ~{' '}
            {foramtDateWithDot(filters.saleDate.end)}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {(filters.approvalDate.start || filters.approvalDate.end) && (
        <Option>
          사용승인
          <SelectedOption onClick={() => setOpenOption('approvalDate')}>
            {foramtDateWithDot(filters.approvalDate.start)} ~{' '}
            {foramtDateWithDot(filters.approvalDate.end)}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {(filters.buildingArea.min || filters.buildingArea.max) && (
        <Option>
          건물면적
          <SelectedOption onClick={() => setOpenOption('buildingArea')}>
            {filters.buildingArea.min && `${filters.buildingArea.min}m²`} ~{' '}
            {filters.buildingArea.max && `${filters.buildingArea.max}m²`}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {(filters.landArea.min || filters.landArea.max) && (
        <Option>
          토지면적
          <SelectedOption onClick={() => setOpenOption('landArea')}>
            {filters.landArea.min && `${filters.landArea.min}m²`} ~{' '}
            {filters.landArea.max && `${filters.landArea.max}m²`}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {filters.bidno && (
        <Option>
          유찰횟수
          <SelectedOption onClick={() => setOpenOption('bidno')}>
            {filters.bidno}회
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {filters.useArea.length !== 0 && (
        <Option>
          용도지역
          <SelectedOption onClick={() => setOpenOption('useArea')}>
            {filters.useArea.length > 1
              ? `${filters.useArea[0]} 외 +${filters.useArea.length - 1}`
              : `${filters.useArea[0]}`}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}

      {filters.specialItemCondition.length !== 0 && (
        <Option>
          특수조건
          <SelectedOption onClick={() => setOpenOption('specialItemCondition')}>
            {filters.specialItemCondition.length > 1
              ? `${filters.specialItemCondition[0]} 외 +${filters.specialItemCondition.length - 1}`
              : `${filters.specialItemCondition[0]}`}
            <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
          </SelectedOption>
        </Option>
      )}
    </OptionList>
  );
}

export default SaveFilterOptionList;

const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  overflow-y: auto;
  height: 100%;
`;

const Option = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 16px;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #37383c9c;
`;

const SelectedOption = styled.div`
  display: flex;
  flex-direction: row;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222;
`;
